import { get, startCase } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  date: {
    borderBottom: `1px solid ${get(theme, 'palette.primary.main')}`,
    height: '10px',
    width: '150px',
  },
  labels: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
  },
  label: {
    fontSize: '12px',
    fontWeight: 'bold',
    margin: '10px 0px',
    minWidth: '150px',
  },
  signature: {
    borderBottom: `1px solid ${get(theme, 'palette.primary.main')}`,
    flex: '1',
    height: '10px',
    marginRight: '15px',
    width: '100%',
  },
  root: {
    flex: '1',
    margin: '15px 0px',
  },
  values: {
    display: 'flex',
  },
}));

export default function PrintableApplicationSignature(props) {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.values}>
        <div className={classes.signature} />
        <div className={classes.date} />
      </div>

      <div className={classes.labels}>
        <div className={classes.label}>{startCase(props.name)}</div>
        <div className={classes.label}>Date</div>
      </div>
    </div>
  );
}

PrintableApplicationSignature.propTypes = {
  name: PropTypes.string.isRequired,
};
